/**
 * Theme Name: project-sscms v1.514.0
 * Theme URI: git+https://github.com/1debit/project-sscms.git
 * Author: Sharp Notions, LLC
 * Author URI: https://sharpnotions.com
 * Description: Wordpress theme for Chime (project-sscms) [main - 884050627]
 * Version: 1.514.0-2025-07-24T18-59-01
 * License: ISC
 * License URI: "http://www.gnu.org/licenses/gpl-2.0.html"
 */
/**
 * File modal.js.
 * Handles logic for modals
 */

function hideModal(modal, cb = () => {}) {
  modal.classList.remove('modal--show');
  modal.querySelector('.modal__focus')?.blur();
  if (cb) cb();
}

function showModal(modal, cb = () => {}) {
  modal.classList.add('modal--show');
  modal.querySelector('.modal__focus')?.focus();
  modal.addEventListener('click', function (e) {
    handleWhitespaceClick(e, cb);
  });
}

function handleWhitespaceClick(e, cb = () => {}) {
  let modal = e.target;
  if (modal.classList.contains('modal--show')) hideModal(modal, cb);
}
